module.exports = __webpack_public_path__ + "static/media/virgin_card_4.7d782a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/virgin_card_4.jpg
// module id = 530
// module chunks = 0